<template>
  <div class="field-editor-form row no-gutters">
    <div class="col-12 mb-3 col-xl-4 pr-xl-3">
      <Field
        type="select"
        name="field_type"
        label="Question Type *"
        v-model="field.type"
        :options="fieldTypes"
        :hideSelectEmptyOption="true"
      />
    </div>
    <div class="col-12 mb-3 col-xl-4 pr-xl-3">
      <Field type="text" name="field_section" label="Section" v-model="field.section" />
    </div>
    <div class="col-12 mb-3 col-xl-4">
      <Field type="text" name="field_points" label="Point Value" v-model="field.points" />
    </div>

    <CheckAllField v-if="isCheckAll" :options.sync="field.options" :answer.sync="field.answer" />
    <MatchingField v-if="isMatching" :options.sync="field.options" :answer.sync="field.answer" />
    <MultipleChoiceField v-if="isMultipleChoice" :field.sync="field" />
    <SequenceField v-if="isSequence" :options.sync="field.options" :answer.sync="field.answer" />
    <TrueFalseField v-if="isTrueFalse" :answer.sync="field.answer" />

    <div class="col-12 mb-3">
      <HtmlField name="field_content" label="Question Text *" v-model="field.content" />
    </div>

    <div class="col-12">
      <a class="btn btn-info mr-2" href="#" @click.prevent="submit()">Attach Question</a>
      <a class="btn btn-danger" href="#" @click.prevent="reset()">Reset Form</a>
    </div>
  </div>
</template>

<script>
import Str from "helpers/Str";
import CheckAllField from "./CheckAllField";
import MatchingField from "./MatchingField";
import MultipleChoiceField from "./MultipleChoiceField";
import SequenceField from "./SequenceField";
import TrueFalseField from "./TrueFalseField";

export const fieldTypeMap = {
  CHECK_ALL_FIELD: "App\\Models\\Forms\\FieldTypes\\CheckAllField",
  MATCHING_FIELD: "App\\Models\\Forms\\FieldTypes\\MatchingField",
  MULTIPLE_CHOICE_FIELD: "App\\Models\\Forms\\FieldTypes\\MultipleChoiceField",
  SEQUENCE_FIELD: "App\\Models\\Forms\\FieldTypes\\SequenceField",
  TEXT_FIELD: "App\\Models\\Forms\\FieldTypes\\TextField",
  TRUE_FALSE_FIELD: "App\\Models\\Forms\\FieldTypes\\TrueFalseField"
};

export const fieldModel = {
  id: Str.random(),
  type: fieldTypeMap.TEXT_FIELD,
  section: "",
  content: "",
  options: null,
  answer: null,
  points: 0,
  include_in_bank: false
};

export default {
  components: {
    CheckAllField,
    MatchingField,
    MultipleChoiceField,
    SequenceField,
    TrueFalseField
  },
  props: {
    value: { type: Object, default: () => {} },
    currentFields: { type: Array, default: () => [] },
    fieldTypes: { type: Array, required: true }
  },
  data() {
    return {
      field: { ...fieldModel }
    };
  },
  computed: {
    fieldTypeLabel() {
      return this.fieldTypes.find(type => type.value == this.field.type).label;
    },
    hasOptions() {
      return ![fieldTypeMap.TEXT_FIELD, fieldTypeMap.TRUE_FALSE_FIELD].includes(
        this.field.type
      );
    },
    isCheckAll() {
      return this.field.type == fieldTypeMap.CHECK_ALL_FIELD;
    },
    isMatching() {
      return this.field.type == fieldTypeMap.MATCHING_FIELD;
    },
    isMultipleChoice() {
      return this.field.type == fieldTypeMap.MULTIPLE_CHOICE_FIELD;
    },
    isSequence() {
      return this.field.type == fieldTypeMap.SEQUENCE_FIELD;
    },
    isText() {
      return this.field.type == fieldTypeMap.TEXT_FIELD;
    },
    isTrueFalse() {
      return this.field.type == fieldTypeMap.TRUE_FALSE_FIELD;
    }
  },
  watch: {
    value(val) {
      // console.log(val);
      if (_.isObject(val) && !_.isEmpty(val)) {
        this.field = val;
        // console.log(this.field);
      }
    },
    "field.type": function(val) {
      this.field.options = null;
      this.field.answer = null;
    }
  },
  methods: {
    setOptions(options) {
      this.field.options = _.cloneDeep(options);
    },
    setAnswer(answer) {
      this.field.answer = _.isObject(answer) ? _.cloneDeep(answer) : answer;
    },
    submit() {
      if (this.validate()) {
        this.$emit("submit", this.field);
        this.reset();
      }
    },
    reset() {
      this.field = { ...fieldModel };
      this.field.id = Str.random();
    },
    validate() {
      var errors = [];
      // validate type selection
      if (!this.field.type) {
        errors.push("No question type selected");
      }
      // validate question text
      if (!this.field.content || this.field.content.length == 0) {
        errors.push("No question text provided");
      }
      // validate answer choices
      if (this.hasOptions) {
        if (this.field.options.length == 0) {
          errors.push("No answer choices provided for question");
        } else {
          var filled = this.field.options.filter(
            opt => !!opt && opt.length > 0
          );
          if (filled.length == 0) {
            errors.push("One or more answer choices are blank or invalid");
          }
        }
      }
      // validate correct answer
      if (
        this.field.type != fieldTypeMap.TEXT_FIELD &&
        (_.isNil(this.field.answer) ||
          (_.isString(this.field.answer) && this.field.answer.length == 0) ||
          (_.isObject(this.field.answer) && _.isEmpty(this.field.answer)))
      ) {
        errors.push("No correct answer provided");
      }
      // display errors
      if (errors.length > 0) {
        alert("Please correct the following: \n\n - " + errors.join("\n - "));
        return false;
      }
      return true;
    }
  }
};
</script>